<template>
  <div class="sp-template tms-order__page">
    <div class="h-title">订单管理</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
          <el-form-item label="状态" v-show="false">
            <el-radio-group v-model="conditions.status" @change="search" size="small">
              <el-radio-button label="未处理" value="1"></el-radio-button>
              <el-radio-button label="完成" value="2"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="产品">
            <el-select v-model="conditions.product" clearable filterable multiple>
              <el-option v-for="(d, i) in channelData" :key="i" :label="d.nameCN" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model.lazy="conditions.stages" clearable filterable>
              <el-option v-for="(d, i) in tmsOrderStages" :key="i" :label="d.name" :value="d.value"></el-option>
            </el-select>
          </el-form-item>
          <!--
          <el-form-item label="审核状态">
            <el-select v-model.lazy="conditions.audit" clearable filterable>
              <el-option v-for="(d, i) in orderAuditStatus" :key="i" :label="d.name" :value="d.value"></el-option>
            </el-select>
          </el-form-item>
          -->
          <el-form-item label="订单号">
            <el-input v-model="numberTextArea" type="textarea" placeholder="多个单号用回车分割" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户订单号">
            <el-input v-model="customerNumberTextArea" type="textarea" placeholder="多个单号用回车分割" clearable></el-input>
          </el-form-item>
          <el-form-item label="转单号">
            <el-input v-model="trackingNumberTextArea" type="textarea" placeholder="多个单号用回车分割" clearable></el-input>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker v-model="conditions.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model="conditions.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="过滤条件">
            <el-checkbox v-model="conditions.detainGoods">扣货订单</el-checkbox>
            <el-checkbox v-model="conditions.purchaseInsurance">保险订单</el-checkbox>
          </el-form-item>
          <el-form-item>
            <!-- <el-button v-if="in_configs(206)" type="primary" @click="search">搜索</el-button> -->
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="onRest">清空</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-button v-show="in_configs(201) && conditions.status == '未处理'" size="small" class="btn-cyan" @click="dialogFormVisible = true">新建订单</el-button>
          <el-button v-show="in_configs(202) && conditions.status == '未处理'" size="small" class="btn-info" @click.stop="uploadOrder()">上传订单</el-button>
          <!-- <el-button v-if="in_configs(202)" size="small" type="primary" @click.stop="uploadOrder()">上传订单</el-button> -->
          <el-button v-show="in_configs(204) && conditions.status == '完成'" size="small" type="success" @click.stop="downloadCartonLabel">下载面单</el-button>
          <el-button v-show="in_configs(205) && conditions.status == '完成'" size="small" type="warning">获取提货码</el-button>

          <el-button v-if="in_configs(211)" class="btn-info" size="small" @click="confirmShipping()">确认发货</el-button>

          <el-button type="primary" size="small" @click="exportCartons()">导出测量数据</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" stripe style="width: 100%" max-height="800" v-loading="loading" element-loading-text="数据加载中，请稍候" @selection-change="handleSelectionChange" :row-class-name="getRowClass">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="订单号"></el-table-column>
        <el-table-column prop="customerOrderNumber" label="客户订单号" width="120"></el-table-column>
        <el-table-column label="转单号">
          <template slot-scope="scope">
            <p v-for="(d,i) in scope.row.masterTrackingNumber" :key="i">
              <a v-if="d && d.substring(0,2) == '1Z'" target="_blank" style="border-bottom:1px solid;" :href="'https://www.ups.com/track?loc=en_US&tracknum='+d+'&requester=WT/trackdetails'" >{{d}}</a>
              <a v-else-if="d && d.substring(0,2) == '78'" target="_blank" style="border-bottom:1px solid;" :href="'https://www.fedex.com/apps/fedextrack/?tracknumber='+d" >{{d}}</a>
              <span v-else >{{d}}</span>
            </p>
            <el-button size="mini" v-show="scope.row.trackingNumbers && scope.row.trackingNumbers.length >0 && scope.row.masterTrackingNumber && scope.row.masterTrackingNumber.length>0" type="text" @click="showTrackingNumber(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="总费用"></el-table-column>
        <el-table-column prop="deliveryTime" label="出仓时间"></el-table-column>
        <el-table-column label="产品">
          <template slot-scope="scope">
            {{scope.row.productName}}
          </template>
        </el-table-column>
        <el-table-column prop="packingList.totalCarton" label="货物箱数"></el-table-column>
        <el-table-column prop="goodsTypeName" label="货物类型"></el-table-column>
        <el-table-column label="预报重量(kg)" width="120">
          <template slot-scope="scope">
            {{calculateTotalWeight(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="实测重量(kg)" width="120">
          <template slot-scope="scope">
            {{calculateTotalActuallyWeight(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="计费重(kg)" width="120">
          <template slot-scope="scope">
            {{scope.row.billedWeight}}
          </template>
        </el-table-column>
        <el-table-column label="超重、超长或大型" width="120">
          <template slot-scope="scope">
            {{scope.row.overWeight?"超重 ":""}}
            {{scope.row.overSize?"超长 ":""}}
            {{scope.row.largeParcel?"大型":""}}
          </template>
        </el-table-column>
        <el-table-column label="自有清关行" width="120" v-if="false">
          <template slot-scope="scope">
            {{showCustomsName(scope.row.customsId)}}
          </template>
        </el-table-column>
        <el-table-column prop="createAt" label="下单时间"></el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            {{scope.row.statusName}}
          </template>
        </el-table-column>
        <!--
        <el-table-column label="审核状态">
          <template slot-scope="scope">
             {{scope.row.audit ? "已审核":"未审核"}}
          </template>
        </el-table-column>
        -->
        <el-table-column label="扣货状态">
          <template slot-scope="scope">
            {{scope.row.detainGoods ? "已扣货":"正常"}}
          </template>
        </el-table-column>
        <el-table-column prop="exceptionMessage" label="异常信息"></el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <!--
            <el-button v-if="in_configs(203) && !scope.row.audit" size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">订单审核</el-button>
            -->
            <el-button v-if="in_configs(207)" size="mini" type="text" @click="showDetail(scope.row.id)">
              <i class="el-icon-view" title="查看详情"></i>
            </el-button>
            <el-button v-if="in_configs(208)" size="mini" type="text" @click="handlePrintPop(scope.row.id)">
              <i class="el-icon-printer" title="面单打印"></i>
            </el-button>
            <a v-if="in_configs(210)" class="download-icon" style="padding: 7px 15px;" @click="downloadTemplate(scope.row)">
              <i class="el-icon-download" title="下载源文件"></i>
            </a>
            <el-button size="mini" v-if="in_configs(212) && conditions.status !== '完成' && scope.row.status !== 'canceled' && (scope.row.status == 'new'
                    || scope.row.status == 'audited' || scope.row.status == 'pick_up_from_customer' || scope.row.status == 'receipt') && !scope.row.jcex " type="text" @click="editOrder(scope.row.id)">
              <i class="el-icon-edit" title="编辑订单"></i>
            </el-button>
            <el-button size="mini" v-if="in_configs(213) && conditions.status !== '完成' && scope.row.status !== 'canceled' && (scope.row.status == 'new'
                    || scope.row.status == 'audited' || scope.row.status == 'pick_up_from_customer' || scope.row.status == 'receipt') && !scope.row.jcex " type="text" @click="editUploadOrder(scope.row)">
              <i class="el-icon-upload" title="编辑上传"></i>
            </el-button>
            <el-button v-if="in_configs(209) && showCancelBtn.indexOf(scope.row.statusName) != -1 && !scope.row.jcex" size="mini" type="text" @click="cancelOrder(scope.$index, scope.row)" 
            style="color: #F56C6C;">
              <i class="el-icon-close" title="取消订单"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="conditions.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="conditions.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <!-- 新建订单 -->
    <el-dialog title="新建订单" :visible.sync="dialogFormVisible" customClass="newOrderModel">
      <el-form :model="createOrderform" size="small" :rules="createOrderformRules" ref="createOrderform">
        <el-form-item label="产品名称" prop="product">
          <el-select v-model="createOrderform.product" filterable clearable placeholder="请选择产品">
            <el-option v-for="(p,i) in channelData" :key="i" :label="p.nameCN" :value="p.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="newOrder">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 上传订单 -->
    <el-dialog title="上传订单" :visible.sync="dialogUpLoadVisible" width="60%">
      <el-form :model="uploadForm" size="small" :rules="uploadFormRule" ref="uploadForm">
        <el-form-item label="产品名称" :label-width="formLabelWidth" prop="productId">
          <el-select v-model="uploadForm.productId" clearable filterable style="width: 350px;">
            <el-option v-for="(p,i) in channelData" :key="i" :label="p.nameCN" :value="p.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取件方式" :label-width="formLabelWidth">
          <el-radio v-model="uploadForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="PICK_UP_FROM_CUSTOMER">预约上门取件</el-radio>
          <el-tooltip class="item" effect="dark" content="我们将在1-2天内上门取件，为收货方便，请提前准备好货物！当运费小于500元时，按货物重量收取费用，详情请查看《上门取件上说明》" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <el-button size="mini" type="text">《上门取件上说明》</el-button>
          <br />
          <el-radio v-model="uploadForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY">送货至仓库</el-radio>
          <el-tooltip class="item" effect="dark" content="请根据您的货物地址，选择距离货物最近的收货仓库" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <br />
          <el-radio v-model="uploadForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY_BY_EXPRESS">快递至仓库</el-radio>
          <el-tooltip class="item" effect="dark" content="请根据您的货物地址，选择距离货物最近的收货仓库" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="取件地址" :label-width="formLabelWidth">
          <el-select v-model="shippingId" placeholder="请选择" @change="selectShippingAddress" v-show="uploadForm.deliveryDetail.deliveryType=='PICK_UP_FROM_CUSTOMER'" clearable filterable style="width: 350px;">
            <el-option v-for="item in shippingList" :key="item.id" :label="item.address" :value="item.id">
              <span>{{ item.country+" "+item.province+" "+item.city+" "+item.address+" "+item.name+" "+item.phone}}</span>
            </el-option>
          </el-select>
          <el-button size="small" type="primary" @click="addressDialogPop()" v-show="uploadForm.deliveryDetail.deliveryType=='PICK_UP_FROM_CUSTOMER'">添加地址</el-button>

          <el-table :data="new Array(uploadForm.deliveryDetail)" :show-header="false" class="table-list" style="width: 100%" v-show="uploadForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' && false">
            <el-table-column prop="province" label="地址" width="70"></el-table-column>
            <el-table-column prop="city" label="地址" width="90"></el-table-column>
            <el-table-column prop="addressFirst" label="地址" width="260"></el-table-column>
            <el-table-column prop="contractName" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑地址</el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-form-item>

        <!-- <el-form-item label="仓库地址" :label-width="formLabelWidth">
          <el-table :data="userCarry" :show-header="false" class="table-list" style="width: 100%">
            <el-table-column label="地址" width="400">
              <template slot-scope="scope">
                【{{scope.row.title}}】{{scope.row.address}}
              </template>
            </el-table-column>
            <el-table-column prop="contractName" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
            <el-table-column label="距离" width="160">
              <template slot-scope="scope">
                {{scope.row.distance + 'km'}}&nbsp;
                <span v-if="scope.row.distance == mapObj.minNumber" style="color: #ff9976">(距离最近)</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleMapEdit(scope.$index, scope.row)">更换仓库</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item> -->

        <el-form-item label="交货仓库地址" :label-width="formLabelWidth">
          <el-select v-model="warehouseId" filterable v-if="flag" placeholder="请选择" @change="selectWarehouse">
            <el-option v-for="item in warehouse" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
          <el-table :data="userCarry" :show-header="false" class="table-list" style="width: 100%">
            <el-table-column label="仓库名称" width="230">
              <template slot-scope="scope">
                {{scope.row.title}}
              </template>
            </el-table-column>
            <el-table-column label="地址" width="230">
              <template slot-scope="scope">
                {{scope.row.address}}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item :label="uploadForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' ? '预约取件时间' : '预计送达时间'" :label-width="formLabelWidth" v-show="uploadForm.deliveryDetail.deliveryType!='DELIVERY_BY_EXPRESS'">
          <el-date-picker v-model="uploadForm.deliveryDetail.appointmentAt" :picker-options="appointmentAtOptions" type="datetime" placeholder="选择日期" style="width: 280px;">
          </el-date-picker>
        </el-form-item>
        <el-row>
          <el-col :span="10" prop="expressCompany">
            <el-form-item label="快递公司" :label-width="formLabelWidth" v-show="uploadForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'">
              <el-input v-model="uploadForm.deliveryDetail.expressCompany" auto-complete="off" placeholder="快递公司"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" prop="expressNumber">
            <el-form-item label="快递单号" :label-width="formLabelWidth" v-show="uploadForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'">
              <el-input v-model="uploadForm.deliveryDetail.expressNumber" auto-complete="off" placeholder="快递单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="模板下载" :label-width="formLabelWidth">
          <a href="../../static/template/new/newFBA-US-A-sample.xlsx" class="template-btn">美国空运模板</a>
          <a href="../../static/template/new/FBA-A-sample.xlsx" class="template-btn">其他空运模板</a>
          <a href="../../static/template/new/newFBA-S-sample.xlsx" class="template-btn">国际海运模板</a>
           <a href="../../static/template/new/railway-sample.xlsx" class="template-btn">国际铁运模板</a>           
        </el-form-item>
        <el-form-item label="文件上传" :label-width="formLabelWidth">
          <el-upload class="upload-demo" ref="uploadExcel" action="#" :limit="1" :on-exceed="exceedFile" :file-list="fileList" :on-change="fileChange" :auto-upload="false" accept=".xlsx">
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="自有清关行" :label-width="formLabelWidth" v-if="false">
          <el-select v-model="uploadForm.customsId" clearable filterable style="width: 350px;">
            <el-option v-for="(customs,i) in filterCustomsList" :key="i" :label="customs.customsName" :value="customs.customsId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeUploadFile()">取 消</el-button>
        <el-button size="small" type="primary" @click="orderUpload">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑订单更新 -->
    <el-dialog title="订单上传更新" :visible.sync="dialogCheckVisibleEditUpload" width="30%">
      <el-form :model="editForm" size="small">
        <el-form-item label="文件上传">
          <el-upload class="upload-demo" ref="uploadExcel" action="#" :limit="1" :on-exceed="exceedFile" :file-list="fileList" :on-change="fileChange" :auto-upload="false" accept=".xlsx">
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip" style="padding-left: 70px;">只能上传xlsx(Excel2007)文件，且不超过10M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisibleEditUpload = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editUploadOrderInfo">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 订单审核 -->
    <el-dialog title="订单审核" :visible.sync="dialogCheckVisible">
      <el-form :model="checkForm" size="small">
        <el-form-item label="审核" :label-width="formLabelWidth">
          <el-radio v-model="checkForm.audit" label='true'>通过</el-radio>
          <el-radio v-model="checkForm.audit" label='false'>不通过</el-radio>
        </el-form-item>
        <el-form-item label="原因" :label-width="formLabelWidth" v-show="checkForm.audit=='false'">
          <el-input v-model="checkForm.auditRemark" placeholder="不通过原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="setingAudit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 地图 -->
    <!-- <sp-amap id="sp-amap" v-if="initialDataWarehouseAddress.length != 0" width="100%" :class="{isOpen: isOpen}" :markers="initialDataWarehouseAddress" :isOpen="isOpen" @get-map-form="getMapForm" @get-geocoder="getGeocoder"></sp-amap> -->

    <!-- 上门取件弹层 -->
    <el-dialog title="编辑地址" :visible.sync="addressFormVisible">
      <el-form size="small">
        <el-form-item label="州/省" :label-width="formLabelWidth">
          <el-select v-model="deliveryDetail.provinceId" @change="queryCityOfChina" filterable>
            <el-option v-for="(province,i) in initialDataProvinceChina" :key="i" :label="province.nameCn" :value="province.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" :label-width="formLabelWidth">
          <el-select v-model="uploadForm.deliveryDetail.city" filterable>
            <el-option v-for="(city,i) in initialDataCityChina" :key="i" :label="city.nameCn" :value="city.nameCn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="formLabelWidth">
          <el-input v-model.lazy="uploadForm.deliveryDetail.addressFirst" placeholder="详细地址"></el-input>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth">
          <el-input v-model.lazy="uploadForm.deliveryDetail.contractName" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="formLabelWidth">
          <el-input v-model.lazy="uploadForm.deliveryDetail.phone" placeholder="电话"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddressOfDeliver">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选取地址" :visible.sync="mapAddressFormVisible" class="gaide-map">
      <!--高德地图-->
      <div ref="spAmap"></div>
      <el-form size="small" class="m-t-20">
        <el-form-item label="已选地址" label-width="70px">
          <b v-text="mapObj.title"></b>
          <span v-text="mapObj.address"></span>
        </el-form-item>
        <el-form-item label="联系人" label-width="70px">
          <span v-text="mapObj.name"></span>
        </el-form-item>
        <el-form-item label="联系电话" label-width="70px">
          <span v-text="mapObj.phone"></span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSmenSaveMap">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="明细" :visible.sync="showTrackingNumberWindow">
      <p v-for="(d,i) in trackingNumbers" :key="i">{{d}}</p>
    </el-dialog>

    <!-- 添加地址 -->
    <el-dialog title="添加地址" :visible.sync="addressDialogVisible" width="60%">
      <addressDialog :shippingForm="shippingForm" v-on:closeAddressPanel="closeAddressPanel()" />
    </el-dialog>

    <!-- 查看订单 弹层 -->
    <el-dialog title="查看订单 " :visible.sync="dialogCheckOrderVisible" width="80%" :before-close="closeCheckOrderDialog">
      <div class="check-order__content">
        <el-card class="box-card">
          <h3 class="sp-card-title">基本信息</h3>
          <el-form :model="orderForm" size="small" inline>
            <el-row>
              <el-form-item label="订单号" label-width="80px">{{orderForm.id}}</el-form-item>
              <el-form-item label="产品" label-width="80px">{{orderForm.productName}}</el-form-item>
              <el-form-item label="取件方式" label-width="80px">{{orderForm.deliveryTypeName}}</el-form-item>
              <el-form-item label="下单时间" label-width="80px">{{orderForm.createAt}}</el-form-item>
              <el-form-item label="一般贸易" label-width="80px">{{orderForm.generalTrade ? "是":"否"}}</el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="总箱数" label-width="80px">{{totalPcs}}</el-form-item>
              <el-form-item label="总件数" label-width="80px">{{totalQty}}</el-form-item>
              <el-form-item label="总重量" label-width="80px">{{toFixed(actuallyTotalWeight,4)}} kg</el-form-item>
              <el-form-item label="总体积" label-width="80px">{{toFixed(actuallyTotalVolume,6)}} cbm</el-form-item>
            </el-row>
          </el-form>
          <div v-for='(item,index) in inspectionFee' :key="index">
                <el-button size="small" v-show="true" type="primary" plain @click="getDownloadUrl(item)">下载查验单 {{index+1}} </el-button>
          </div>
          <h3 class="sp-card-title">进度跟踪</h3>
          <div >
            <!--
            <el-row>
              <el-col :span="14">
                <el-steps :active="active" finish-status="success">
                  <el-step v-for="(d,i) in orderForm.taskStages" :key="i" :title="d.stageName"></el-step>
                </el-steps>
              </el-col>
              
              <el-col :span="14">
                <el-card class="m-t-20">
                  <div slot="header" class="clearfix">
                    <span>进度详情</span>
                  </div>
                  <div v-for="(d,i) in orderForm.trackingValues" :key="i" class="text item">
                    {{d.at}}&nbsp;&nbsp;
                    <b>{{d.eventName}} {{!d.trackingNo?"":"["+d.trackingNo+"]"}}</b>&nbsp;&nbsp;{{d.detail}}
                  </div>
                </el-card>
              </el-col>
              
            </el-row>
            -->
            <div class="step-content">
              <h1 class="step-content__title">订单轨迹跟踪</h1>
              <el-steps :active="1" :space="80" finish-status="success" direction="vertical">
                <el-step 
                  v-for="(d,i) in orderTrackingArray" 
                  :key="i" 
                  :title='d.event'>
                  <div v-if="d.event!='新建订单' && d.event!='已收货' && d.event!='已测量'" slot="description">
                      <p v-if="d.at!=null && d.at!=''">计划时间：{{d.at}}</p>
                      <p v-if="d.actualAt!=null && d.actualAt!=''">实际时间：{{d.actualAt}}</p>
                      <p v-if="d.detail!=null && d.detail!=''">备注：{{d.detail}}</p>
                  </div>
                  <div v-else slot="description">
                      <p v-if="d.at!=null && d.at!=''">实际时间：{{d.at}}</p>
                      <p v-if="d.detail!=null && d.detail!=''">备注：{{d.detail}}</p>
                  </div>
                </el-step>
              </el-steps>
            </div>
            <!-- <el-table
              :data="orderTrackingArray"
              v-show="orderTrackingArray && orderTrackingArray.length > 0"
              style="width: 1000px;"
              border>
              <el-table-column label="订单轨迹记录" prop="eventName"></el-table-column>
              <el-table-column label="详情" prop="detail"></el-table-column>
              <el-table-column label="时间" prop="at"></el-table-column>
            </el-table> -->
            <div class="step-content">
              <h1 class="step-content__title">追单号轨迹跟踪</h1>
              <table 
                v-show="trackingNumberArray && trackingNumberArray.length > 0" 
                class="el-table tracking-number__table" 
                style="width: 1000px;">
                <thead>
                  <tr>
                    <th></th>
                    <th>转单号</th>
                    <th>订单轨迹记录</th>
                    <!-- <th>详情</th> -->
                    <th>时间</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in trackingNumberArray" :key="index">
                    <td>
                      <a href="#" 
                        v-show="item.details && item.details.length > 1"
                        :class="[item.collapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down']" 
                        @click.prevent="item.collapsed = !item.collapsed">
                      </a>
                    </td>
                    <td>{{item.trackingNo}}</td>
                    <td>
                      <div 
                        class="item" 
                        v-if="item.collapsed">
                        {{item.details[0].eventName}}
                      </div>
                      <div 
                        class="item" 
                        v-if="!item.collapsed" 
                        v-for="(detail, idx) in item.details" 
                        :key="idx">
                        {{detail.eventName}}
                      </div>
                    </td>
                    <!-- <td>
                      <div 
                        class="item" 
                        v-if="item.collapsed">
                        {{item.details[0].detail}}
                      </div>
                      <div 
                        class="item" 
                        v-if="!item.collapsed" 
                        v-for="(detail, idx) in item.details" 
                        :key="idx">
                        {{detail.detail}}
                      </div>
                    </td> -->
                    <td>
                      <div 
                        class="item" 
                        v-if="item.collapsed">
                        {{item.details[0].eventAt}}
                      </div>
                      <div 
                        class="item" 
                        v-if="!item.collapsed" 
                        v-for="(detail, idx) in item.details" 
                        :key="idx">
                        {{detail.eventAt}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="m-b-10">
            <el-button size="small" type="text" @click="show = !show">
              <span v-if="!show">
                <i class="el-icon-arrow-down"></i>&nbsp;展开订单详情</span>
              <span v-else>
                <i class="el-icon-arrow-up"></i>&nbsp;收起订单详情</span>
            </el-button>
          </div>

          <el-collapse-transition>
            <div v-show="show">
              <h3 class="sp-card-title">订单信息</h3>
              <el-form :model="orderForm" size="small">
                <el-row>
                  <el-col :span="10">
                    <el-form-item v-show="false" label="是否是FBA地址" :label-width="formLabelWidth">是</el-form-item>
                    <el-form-item label="客户单号" :label-width="formLabelWidth">{{orderForm.customerRefnumber.customerOrderNumber}}</el-form-item>
                    <el-form-item label="公司名称" :label-width="formLabelWidth">{{orderForm.shippingDetail.address.companyName}}</el-form-item>
                    <el-form-item label="联系电话" :label-width="formLabelWidth">{{orderForm.shippingDetail.contractDatail.phone}}</el-form-item>
                    <el-form-item label="州/省" :label-width="formLabelWidth">{{orderForm.shippingDetail.address.province}}</el-form-item>
                    <el-form-item label="城市" :label-width="formLabelWidth">{{orderForm.shippingDetail.address.city}}</el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="FBA号" :label-width="formLabelWidth">{{orderForm.customerRefnumber.fbaNumber}}</el-form-item>
                    <el-form-item label="联系人" :label-width="formLabelWidth">{{orderForm.shippingDetail.contractDatail.name}}</el-form-item>
                    <el-form-item label="国家" :label-width="formLabelWidth">{{orderForm.shippingDetail.address.country}}</el-form-item>
                    <el-form-item label="邮编" :label-width="formLabelWidth">{{orderForm.shippingDetail.address.zipcode}}</el-form-item>
                    <el-form-item label="FBA仓码" :label-width="formLabelWidth">{{orderForm.shippingDetail.address.fbaWarehouseCode}}</el-form-item>
                    <el-form-item label="Amazon Ref Id" :label-width="formLabelWidth">{{orderForm.amazonReferenceId}}</el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="详细地址1" :label-width="formLabelWidth">{{orderForm.shippingDetail.address.address}}</el-form-item>
                    <el-form-item label="详细地址2" :label-width="formLabelWidth">{{orderForm.shippingDetail.address.address2}}</el-form-item>
                  </el-col>
                </el-row>
                <h3 v-if="false" class="sp-card-title">本地地址</h3>
                <el-row v-if="false">
                  <el-col :span="10">
                    <el-form-item label="联系人" :label-width="formLabelWidth">
                      {{orderForm.localLanguageDetail == null ? "" : orderForm.localLanguageDetail.contractDatail.name}}
                    </el-form-item>
                    <el-form-item label="州/省" :label-width="formLabelWidth">
                      {{orderForm.localLanguageDetail == null ? "" : orderForm.localLanguageDetail.address.province}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="国家" :label-width="formLabelWidth">
                      {{orderForm.localLanguageDetail == null ? "" : orderForm.localLanguageDetail.address.country}}
                    </el-form-item>
                    <el-form-item label="城市" :label-width="formLabelWidth">
                      {{orderForm.localLanguageDetail == null ? "" : orderForm.localLanguageDetail.address.city}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="详细地址1" :label-width="formLabelWidth">
                      {{orderForm.localLanguageDetail == null ? "" : orderForm.localLanguageDetail.address.address}}
                    </el-form-item>
                    <el-form-item label="详细地址2" :label-width="formLabelWidth">
                      {{orderForm.localLanguageDetail == null ? "" : orderForm.localLanguageDetail.address.address2}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <h3 class="sp-card-title">商品信息</h3>
              <el-form :model="orderForm" size="small">
                <el-row>
                  <el-col :span="10">
                    <el-form-item label="货物类型" :label-width="formLabelWidth">{{orderForm.goodsTypeName}}</el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="货物箱数" :label-width="formLabelWidth">{{orderForm.packingList.totalCarton}}</el-form-item>
                  </el-col>
                </el-row>
                <el-table :data="orderForm.packingList.cartonDetails" class="m-b-20" style="width: 100%;">
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <table class="table" border="1">
                        <thead>
                          <tr>
                            <th>SKU</th>
                            <th>数量</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(data, index) in props.row.items" :key="index">
                            <td>{{data.sku}}</td>
                            <td>{{data.qty}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </el-table-column>
                  <el-table-column property="customerCartonNumber" label="客户箱号"></el-table-column>
                  <el-table-column property="cartonNumber" label="系统箱号"></el-table-column>
                  <el-table-column property="length" label="预报长(cm)"></el-table-column>
                  <el-table-column property="width" label="预报宽(cm)"></el-table-column>
                  <el-table-column property="height" label="预报高(cm)"></el-table-column>
                  <el-table-column property="weight" label="预报毛重(kg)"></el-table-column>
                  <el-table-column property="actuallyLength" label="实测长(cm)"></el-table-column>
                  <el-table-column property="actuallyWidth" label="实测宽(cm)"></el-table-column>
                  <el-table-column property="actuallyHeight" label="实测高(cm)"></el-table-column>
                  <el-table-column property="actuallyWeight" label="实测毛重(kg)"></el-table-column>
                  <!-- <el-table-column label="SKU信息">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="showSku(scope.row)">查看SKU</el-button>
                  </template>
                </el-table-column> -->
                </el-table>
                <el-row>
                  <el-col :span="10">
                    <el-form-item label="预报总重量" :label-width="formLabelWidth">{{toFixed(totalWeight,4)}} kg</el-form-item>
                    <el-form-item label="实测总重量" :label-width="formLabelWidth">{{toFixed(actuallyTotalWeight,4)}} kg</el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="预报总体积" :label-width="formLabelWidth">{{toFixed(totalVolume,6)}} cbm</el-form-item>
                    <el-form-item label="实测总体积" :label-width="formLabelWidth">{{toFixed(actuallyTotalVolume,6)}} cbm</el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-collapse-transition>
          <div class="m-b-10">
            <el-button v-show="in_configs(214)" size="small" type="text" @click="showCost = !showCost">
              <span v-if="!showCost">
                <i class="el-icon-arrow-down"></i>&nbsp;展开订单费用</span>
              <span v-else>
                <i class="el-icon-arrow-up"></i>&nbsp;收起订单费用</span>
            </el-button>
          </div>
          <el-collapse-transition>
            <div v-show="showCost">
              <h3 class="sp-card-title">订单费用</h3>
              <el-form :model="orderForm" size="small">

                <el-table :data="costData" class="m-b-20" border style="width: 100%;">
                  <el-table-column label="实重">
                    <template slot-scope="scope">
                      {{toFixed(scope.row.actuallyWeight,3)}}
                    </template>
                  </el-table-column>
                  <el-table-column label="计费重">
                    <template slot-scope="scope">
                      {{toFixed(scope.row.chargingWeight,3)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalAmount" label="总费用"></el-table-column>
                  <el-table-column width="180" label="费用类型">
                    <template slot-scope="scope">
                      <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.serviceType}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" label="金额">
                    <template slot-scope="scope">
                      <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.amount}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" label="币种">
                    <template slot-scope="scope">
                      <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.currency}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column width="200" label="交易时间">
                    <template slot-scope="scope">
                      <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.txDate}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" label="明细">
                    <template slot-scope="scope">
                      <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">
                        <a href="#" title="点击查看明细" @click.prevent="showAllBasicVariables(d.trace)">
                          <i class="el-icon-zoom-in"></i>
                        </a>
                        {{d.trace}}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" label="备注">
                    <template slot-scope="scope">
                      <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">
                        <el-tooltip v-if="d.remarks && d.remarks !== ''" effect="dark" placement="top">
                          <div slot="content">
                            <div>{{d.remarks}}</div>
                          </div>
                          <i class="el-icon-question"></i>
                        </el-tooltip>
                        <span>{{d.remarks}}</span>
                      </div>
                    </template>
                  </el-table-column>

                </el-table>

              </el-form>
            </div>

          </el-collapse-transition>
        </el-card>
      </div>
    </el-dialog>
    <el-dialog title="明细" :visible.sync="dialogShowVariables" append-to-body>
      <p v-if="formulaStr !== ''" v-html="formulaStr"></p>
    </el-dialog>

    <!-- 提示弹框2 -->
    <el-dialog title="打印箱标" :visible.sync="dialogCheckVisible2">
      <el-form size="small">
        <el-form-item label="打印规格" :label-width="formLabelWidth">
          <el-select v-model="printType">
            <el-option v-for="(d, i) in printTypes" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible2 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handlePrint()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import addressDialog from "../usercenter/address_dialog";
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    var checkAppointmentAt = (rule, value, callback) => {
      if (false) {
        callback(new Error("详细地址1必填"));
      } else {
        callback();
      }
    };
    return {
      showCancelBtn: ["新增", "审核", "上门取货"],
      isJP: false,
      dialogCheckVisibleEditUpload: false,
      dialogCheckVisible2: false,
      printType: "SINGLE",
      printTypes: [
        { id: "SINGLE", name: "100x100" },
        { id: "A4", name: "A4" }
      ],
      thePrintId: "",

      dialogShowVariables: false,
      formulaStr: "",
      addressDialogVisible: false,
      shippingForm: {},
      conditions: {
        status: "未处理",
        product: [],
        number: "",
        customerNum: "",
        trackingNum: "",
        startDate: "",
        endDate: "",
        batch: "",
        detainGoods: false,
        purchaseInsurance: false,
        currentPage: 1,
        pageSize: 10
      },
      tableData: [],
      multipleSelection: [],
      customerList: [],
      tmsOrderStages: [],
      trackingNumberArray: [],
      orderTrackingArray: [],
      orderAuditStatus: [],
      form: {
        test: "",
        product: "",
        customer: ""
      },
      loading: true,
      addressFormVisible: false,
      initialDataFbaAddress: [],
      customsList: [],
      initialDataCountry: [],
      initialDataProvince: [],
      initialDataCity: [],
      initialDataProvinceChina: [],
      initialDataCityChina: [],
      initialDataWarehouseAddress: [],
      currentWarehouseAddress: "",
      uploadForm: {
        productId: "",
        warehouseId: "",
        customsId: "",
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: new Date(),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        }
      },
      deliveryDetail: {
        provinceId: "",
        cityId: ""
      },
      mapAddressFormVisible: false,
      dialogFormVisible: false,
      dialogUpLoadVisible: false,
      dialogCheckVisible: false,
      formLabelWidth: "120px",
      checkForm: {
        audit: false,
        auditRemark: null
      },
      total: 0,
      createOrderform: {
        product: "",
        customer: ""
      },
      createOrderformRules: {
        product: [{ required: true, message: "请选择产品", trigger: "change" }],
        appointmentAt: [
          {
            validator: checkAppointmentAt,
            trigger: "change"
          }
        ]
      },
      channelData: [],
      channelDataMap: {},
      warehouseData: [],
      fileList: [],
      templateFile: "",
      uploadFormRule: {
        productId: [
          { required: true, message: "请选择产品", trigger: "change" }
        ]
      },
      //高德地图
      isInit: true,
      isOpen: false,
      markers: [
        {
          id: "",
          title: "【东莞仓】",
          position: [113.753228, 22.9833],
          address: "广东省东莞市南城街道东骏豪苑(东骏路)",
          name: "blry",
          phone: "13713262222"
        }
      ],
      mapObj: {},
      userCarry: [
        {
          title: "",
          address: "",
          name: "",
          phone: "",
          distance: ""
        }
      ],
      appointmentAtOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "明天",
            onClick(picker) {
              let _tomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24
                ).toLocaleDateString()
              );
              picker.$emit("pick", _tomorrow);
            }
          },
          {
            text: "后天",
            onClick(picker) {
              let _afterTomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24 * 2
                ).toLocaleDateString()
              );
              picker.$emit("pick", _afterTomorrow);
            }
          }
        ],
        disabledDate(time) {
          return time < new Date(new Date().toLocaleDateString()).getTime();
        }
      },
      shippingList: [],
      shippingId: "",
      showTrackingNumberWindow: false,
      trackingNumbers: [],
      numberTextArea: "",
      customerNumberTextArea: "",
      trackingNumberTextArea: "",
      flag: false,
      warehouseData: [],
      warehouseId: "",
      warehouse: [],
      dialogCheckOrderVisible: false,
      orderForm: {
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        shippingDetail: {
          address: {
            province: "",
            country: "",
            city: "",
            address: "",
            address2: "",
            companyName: ""
          },
          contractDatail: { phone: "", name: "" }
        },
        localLanguageDetail: {
          address: {
            province: "",
            country: "",
            city: "",
            address: "",
            address2: ""
          },
          contractDatail: { phone: "", name: "" }
        },
        packingList: {
          goodsType: "",
          totalCarton: ""
        }
      },
      totalPcs: 0,
      totalQty: 0,
      totalVolume: 0,
      totalWeight: 0,
      actuallyTotalVolume: 0,
      actuallyTotalWeight: 0,
      active: 0,
      show: false,
      showCost: false,
      inspectionFee: [],
      costData: [],
      editForm: {
        orderId: "",
        orgOwner: "",
        orgOp: "",
        warehousCode: "",
        productId: "",
        product: "",
        remark: "",
        warehouseId: "",
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: new Date(),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        }
      }
    };
  },
  components: {
    addressDialog
  },
  computed: {
    filterCustomsList: function() {
      var key = this.key;
      var customsList = this.customsList;
      return customsList.filter(function(item) {
        return item.status > 0;
      });
    }
  },
  created() {
    let _this = this;

    setTimeout(() => {
      _this.onLoad();
      _this.queryCustomsList();
    }, 800);
  },
  methods: {
    showCustomsName(customsId) {
      var _value = "";
      this.customsList.forEach((d, i) => {
        if (d.customsId == customsId) {
          _value = d.customsName;
        }
      });
      return _value;
    },
    //查询清关行&报关行
    queryCustomsList() {
      let _this = this;
      _this.$request1
        .get(
          '/customs/load',
          {
            params: {
              customsName: "",
              customsType: "",
              currentPage: 1,
              pageSize: 100
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.customsList = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 下载模板
    downloadTemplate(row) {
      // 测试用的id和url
      // id = 'ITDEA1807250003'
      // let url = `https://starpost-test.oss-cn-shenzhen.aliyuncs.com/${id}-upload-excel.xlsx`
      // let url = `https://starpost-public-read.oss-cn-shenzhen.aliyuncs.com/${id}-upload-excel.xlsx`;

      let parent = event.target.parentNode;
      parent.setAttribute("href", row.sourceFileUrl);
      parent.setAttribute("target", "_blank");
    },
    showAllBasicVariables(vars) {
      this.formulaStr = vars.replace(/\n/g, "<br>");
      this.dialogShowVariables = true;
    },

    getDownloadUrl(fileName) {
      let _this = this;
      if (!fileName || fileName == "") {
        _this.$message.error("文件名为空");
        return false;
      }
      this.$request1
        .post(
          '/order/fileDownload/' + fileName + ''
        )
        .then(res => {
          if (res.data.success) {
            location.href = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 清空表单
    onRest() {
      this.conditions = {
        audit: "",
        status: "未处理",
        product: [],
        number: "",
        customerNum: "",
        trackingNum: "",
        startDate: "",
        endDate: "",
        batch: "",
        detainGoods: false,
        purchaseInsurance: false,
        currentPage: 1,
        pageSize: 10
      };
      this.numberTextArea = "";
      this.customerNumberTextArea = "";
      this.trackingNumberTextArea = "";
      this.onSubmit();
    },
    calculateTotalWeight(row) {
      let totalWeight = 0;
      if (row.packingList.cartonDetails) {
        row.packingList.cartonDetails.forEach((d, i) => {
          totalWeight += d.weight ? d.weight : 0;
        });
      }
      return this.toFixed(totalWeight, 4);
    },
    calculateTotalActuallyWeight(row) {
      let totalWeight = 0;
      if (row.packingList.cartonDetails) {
        row.packingList.cartonDetails.forEach((d, i) => {
          totalWeight += d.actuallyWeight ? d.actuallyWeight : 0;
        });
      }
      return this.toFixed(totalWeight, 4);
    },
    toFixed(num, len) {
      if (!num || isNaN(num)) {
        return "";
      }
      var times = Math.pow(10, len);
      var des = num * times + 0.5;
      return parseInt(des, 10) / times;
    },
    onLoad() {
      //页面初始化
      let _this = this;
      //加载订单节点状态名称
      _this.loadTmsOrderStages();
      _this.loadOrderAuditStatus();
      // 加载中国省份 loadTmsOrderStages中
      // _this.queryProvinceOfChina();
      // 加载仓库地址 loadTmsOrderStages中
      // _this.queryAddress("SHIPPING");
      // 加载产品放在 loadTmsOrderStages中
      // _this.loadChannel();
      // 加载仓库地址放在 loadChannel中
      //_this.loadWarehouse();
      // 加载订单放在 loadWarehouse中
      //_this.onSubmit();
      _this.loading = false;
    },
    //打开上传订单窗口
    uploadOrder() {
      // 清理上传订单form表单
      this.uploadForm.deliveryDetail.deliveryType = "PICK_UP_FROM_CUSTOMER";
      this.templateFile = null;
      this.fileList = [];
      // this.uploadForm.productId = "";
      // this.uploadForm.deliveryDetail = {
      //   deliveryType: "PICK_UP_FROM_CUSTOMER",
      //   warehouseCode: "",
      //   appointmentAt: new Date(),
      //   expressCompany: "",
      //   expressNumber: "",
      //   contractName: "",
      //   phone: "",
      //   country: "",
      //   province: "",
      //   city: "",
      //   addressFirst: ""
      // };
      this.dialogUpLoadVisible = true;
    },
    closeUploadFile() {
      this.templateFile = "";
      this.$refs.uploadExcel.clearFiles();
      this.dialogUpLoadVisible = false;
    },
    getRowClass({ row, rowIndex }) {
      if (row.exception) {
        return "red";
      } else {
        return "";
      }
    },
    search() {
      // Click Search Button
      this.conditions.currentPage = 1;
      this.onSubmit();
    },
    //搜索
    onSubmit(orderId) {
      let _this = this;

      _this.conditions.number = [];
      if (orderId && orderId.length > 0) {
        _this.conditions.number.push(orderId);
      } else {
        _this.numberTextArea.split(/\n+/gim).forEach((d, i) => {
          if (d && d != "") {
            _this.conditions.number.push(d);
          }
        });
      }
      _this.conditions.customerNum = [];
      _this.customerNumberTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          _this.conditions.customerNum.push(d);
        }
      });
      _this.conditions.trackingNum = [];
      _this.trackingNumberTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          _this.conditions.trackingNum.push(d);
        }
      });
      //清空数据
      _this.orderForm = {
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        shippingDetail: {
          address: {
            province: "",
            country: "",
            city: "",
            address: "",
            address2: ""
          },
          contractDatail: { phone: "", name: "" }
        },
        packingList: {
          goodsType: "",
          totalCarton: ""
        }
      };
      _this.orderTrackingArray = [];
      _this.totalPcs = 0;
      _this.totalQty = 0;
      _this.totalWeight = 0;
      _this.totalVolume = 0;
      _this.actuallyTotalWeight = 0;
      _this.actuallyTotalVolume = 0;

      _this.$request1
        .post(
          '/order/query',
          {
              isDone: _this.conditions.status == "完成",
              productIds: _this.conditions.product,
              orderId: _this.conditions.number,
              customerOrderNumber: _this.conditions.customerNum,
              trackingNumber: _this.conditions.trackingNum,
              stages: _this.conditions.stages,
              startDate: _this.conditions.startDate,
              endDate: _this.conditions.endDate,
              detainGoods: _this.conditions.detainGoods,
              purchaseInsurance: _this.conditions.purchaseInsurance,
              currentPage: _this.conditions.currentPage,
              pageSize: _this.conditions.pageSize,
              audit: _this.conditions.audit
            },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            if (orderId && orderId.length > 0) {
              _this.orderForm = res.data.data[0];
              if (
                _this.orderForm.trackingValues &&
                _this.orderForm.trackingValues.length > 0
              ) {
                let trackingNumberMap = {},
                  trackingNumberList = [];
                _this.orderForm.trackingValues.forEach(item => {
                  if (item.trackingNo && item.trackingNo !== "") {
                    if (!trackingNumberList.includes(item.trackingNo)) {
                      trackingNumberList.push(item.trackingNo);
                    }
                    if (!trackingNumberMap[item.trackingNo]) {
                      trackingNumberMap[item.trackingNo] = new Array(item);
                    } else {
                      trackingNumberMap[item.trackingNo].unshift(item);
                    }
                  } else {
                    _this.orderTrackingArray.unshift(item);
                    _this.orderTrackingArray.forEach(item => {
                      if (item.detail) {
                        item.event = `${item.eventName}`;
                      } else {
                        item.event = `${item.eventName}`;
                      }
                    });
                  }
                });
              }
              if (
                _this.orderForm.shippingDetail.address.country == "JP" ||
                _this.orderForm.shippingDetail.address.country == "Japan"
              ) {
                _this.isJP = true;
              } else {
                _this.isJP = false;
              }

              _this.orderForm.packingList.cartonDetails.forEach((d, i) => {
                _this.totalWeight += d.weight ? d.weight : 0;
                _this.totalVolume +=
                  ((d.length ? d.length : 0) *
                    (d.width ? d.width : 0) *
                    (d.height ? d.height : 0)) /
                  1000000;
                _this.actuallyTotalWeight += d.actuallyWeight
                  ? d.actuallyWeight
                  : 0;
                _this.actuallyTotalVolume +=
                  ((d.actuallyLength ? d.actuallyLength : 0) *
                    (d.actuallyWidth ? d.actuallyWidth : 0) *
                    (d.actuallyHeight ? d.actuallyHeight : 0)) /
                  1000000;
                d.items.forEach((dd, ii) => {
                  _this.totalQty += dd.qty;
                });
              });
              _this.totalPcs = _this.orderForm.packingList.cartonDetails.length;
              if (_this.orderForm.customerRefnumber == null) {
                _this.orderForm.customerRefnumber = {
                  customerOrderNumber: "",
                  fbaNumber: ""
                };
              }
            } else {
              _this.tableData = res.data.data;
              _this.total = res.data.total;
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {});
    },
    queryAddress(type) {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/address/query',
        params: {
          type: type
        }
      })
        .then(res => {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              this.shippingList = res.data.data;
              this.shippingList.forEach((d, i) => {
                if (d.defaultAddress) {
                  this.selectShippingAddress(d.id);
                }
              });
            } else {
              this.shippingList = [];
            }
          } else {
            _this.$message.error(res.data.message);
            this.shippingList = [];
          }
        })
        .catch(error => {});
    },
    selectShippingAddress(id) {
      this.shippingList.forEach((d, i) => {
        if (d.id == id) {
          this.shippingId = id;
          this.uploadForm.deliveryDetail.province = d.province;
          this.uploadForm.deliveryDetail.city = d.city;
          this.uploadForm.deliveryDetail.addressFirst = d.address;
          this.uploadForm.deliveryDetail.contractName = d.name;
          this.uploadForm.deliveryDetail.phone = d.phone;
        }
      });
    },
    queryProvinceOfChina() {
      var _this = this;
      _this.$request1
        .get(
          '/province/' + 1 + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvinceChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {});
    },
    showDetail(id) {
      let _this = this;
      // _this.$router.push("/checkorder?id=" + id);
      _this.loadInspectionFee(id);
      _this.loadData(id);
      //查询订单费用
      _this.loadCost(id);
      _this.queryTrackingInfo(id);
      this.dialogCheckOrderVisible = true;
    },
    loadInspectionFee(id) {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/order/inspectionFee/' + id + '',
        withCredentials: true
      })
        .then(response => {
          _this.inspectionFee = response.data.data;
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    // 查看订单详情，根据ID查询订单
    loadData(id) {
      let _this = this;
      _this.orderForm = {
        customerRefnumber: {
          customerOrderNumber: "",
          fbaNumber: ""
        },
        shippingDetail: {
          address: {
            province: "",
            country: "",
            city: "",
            address: "",
            address2: ""
          },
          contractDatail: {
            phone: "",
            name: ""
          }
        },
        localLanguageDetail: {
          address: {
            province: "",
            country: "",
            city: "",
            address: "",
            address2: ""
          },
          contractDatail: {
            phone: "",
            name: ""
          }
        },
        packingList: {
          goodsType: "",
          totalCarton: ""
        },
        taskStages: []
      };
      _this.orderTrackingArray = [];
      _this.active = 0;
      _this.totalPcs = 0;
      _this.totalQty = 0;
      _this.totalWeight = 0;
      _this.totalVolume = 0;
      _this.actuallyTotalWeight = 0;
      _this.actuallyTotalVolume = 0;
      _this.$request1.post(
          '/order/query',
          {
              status: "",
              productId: "",
              orderId: [id],
              startDate: "",
              endDate: "",
              currentPage: 1,
              pageSize: 1,
              searchException: _this.conditions.status == "异常订单"
            },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              _this.orderForm = res.data.data[0];
              if (
                _this.orderForm.trackingValues &&
                _this.orderForm.trackingValues.length > 0
              ) {
                let trackingNumberMap = {},
                  trackingNumberList = [];
                _this.orderForm.trackingValues.forEach(item => {
                  if (item.trackingNo && item.trackingNo !== "") {
                    if (!trackingNumberList.includes(item.trackingNo)) {
                      trackingNumberList.push(item.trackingNo);
                    }
                    if (!trackingNumberMap[item.trackingNo]) {
                      trackingNumberMap[item.trackingNo] = new Array(item);
                    } else {
                      trackingNumberMap[item.trackingNo].unshift(item);
                    }
                  } else {
                    _this.orderTrackingArray.unshift(item);
                    _this.orderTrackingArray.forEach(item => {
                      if (item.detail) {
                        item.event = `${item.eventName}`;
                      } else {
                        item.event = `${item.eventName}`;
                      }
                    });
                    // 已出货之后的轨迹不展示时分秒
                    let flag = false;
                    for (
                      let i = _this.orderTrackingArray.length - 1;
                      i >= 0;
                      i--
                    ) {
                      let t = _this.orderTrackingArray[i];
                      if (t.eventName == "已出货") {
                        flag = true;
                      }
                      if (flag) {
                        if (t.at != null && t.at != "" && t.at.length > 10) {
                          t.at = t.at.substring(0, 10);
                        }
                        if (
                          t.actualAt != null &&
                          t.actualAt != "" &&
                          t.actualAt.length > 10
                        ) {
                          t.actualAt = t.actualAt.substring(0, 10);
                        }
                      }
                    }
                  }
                });
              }

              _this.orderForm.packingList.cartonDetails.forEach((d, i) => {
                _this.totalWeight += d.weight ? d.weight : 0;
                _this.totalVolume +=
                  ((d.length ? d.length : 0) *
                    (d.width ? d.width : 0) *
                    (d.height ? d.height : 0)) /
                  1000000;
                _this.actuallyTotalWeight += d.actuallyWeight
                  ? d.actuallyWeight
                  : 0;
                _this.actuallyTotalVolume +=
                  ((d.actuallyLength ? d.actuallyLength : 0) *
                    (d.actuallyWidth ? d.actuallyWidth : 0) *
                    (d.actuallyHeight ? d.actuallyHeight : 0)) /
                  1000000;
                d.items.forEach((dd, ii) => {
                  _this.totalQty += dd.qty;
                });
              });
              _this.totalPcs = _this.orderForm.packingList.cartonDetails.length;
              if (_this.orderForm.customerRefnumber == null) {
                _this.orderForm.customerRefnumber = {
                  customerOrderNumber: "",
                  fbaNumber: ""
                };
              }
            } else {
              _this.$message.error("Data not found!");
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {});
    },
    loadCost(orderId) {
      let _this = this;
      _this.costData = [];
      this.$request1({
        method: 'post',
        url: '/order/charge/query',
        withCredentials: true,
        data: {
          orderIds: [orderId],
          startDate: "",
          endDate: "",
          currentPage: 1,
          pageSize: 500,
          export: 0
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            _this.costData = data.data;
          } else {
            _this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    newOrder() {
      let _this = this;
      _this.$refs["createOrderform"].validate(valid => {
        if (valid) {
          _this.dialogFormVisible = false;
          let productType = "";
          _this.channelData.forEach((d, i) => {
            if (_this.createOrderform.product == d.id) {
              productType = d.channelType;
            }
          });
          this.$router.push(
            "/neworder?product=" +
              _this.createOrderform.product +
              "&productType=" +
              productType
          );
        } else {
          return false;
        }
      });
    },
    downloadCartonLabel() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }
    },
    loadOrderAuditStatus() {
      let _this = this;
      _this.$request1
        .get(
          '/order/auditStatus',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          _this.orderAuditStatus = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadTmsOrderStages() {
      let _this = this;
      _this.$request1
        .get(
          '/order/stage',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          _this.tmsOrderStages = res.data;
          _this.loadChannel();
          _this.queryProvinceOfChina();
          _this.queryAddress("SHIPPING");
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    formatterDate(row, column) {
      return new Date(row.createAt).toLocaleString();
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //订单审核
    handleEdit(index, row) {
      this.checkForm = {
        orderId: row.id,
        index: index,
        audit: row.audit + "",
        auditRemark: row.auditRemark
      };
      this.dialogCheckVisible = true;
    },
    //编辑订单
    editOrder(orderId) {
      // this.$notify.info({
      //   title: "提示",
      //   message: "功能开发中"
      // });
      // console.log(orderId);
      this.$router.push({
        path: "/editorder",
        query: {
          orderId: orderId
        }
      });
    },
    setingAudit() {
      // let _this = this;
      // _this.$request1
      //   .post(
      //     jsRoutes.controllers.order.OrderController.modifyOrderAudit(),
      //     {
      //       orderId: _this.checkForm.orderId,
      //       audit: _this.checkForm.audit,
      //       auditRemark: _this.checkForm.auditRemark
      //     },
      //     {
      //       withCredentials: true
      //     }
      //   )
      //   .then(function(res) {
      //     if (res.data.success) {
      //       _this.tableData[_this.checkForm.index].audit =
      //         _this.checkForm.audit === "true";
      //       _this.tableData[_this.checkForm.index].auditRemark =
      //         _this.checkForm.auditRemark;
      //       _this.dialogCheckVisible = false;
      //     } else {
      //       _this.$message.error(res.data.message);
      //     }
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
    },
    //分页
    handleSizeChange(val) {
      this.conditions.currentPage = 1;
      this.conditions.pageSize = val;
      this.onSubmit();
    },
    handleCurrentChange(val) {
      this.conditions.currentPage = val;
      this.onSubmit();
    },
    findByCustomerName() {
      // let _this = this;
      // _this.$request1
      //   .get(
      //     jsRoutes.controllers.customer.CustomerController.filterCustomer(),
      //     {
      //       withCredentials: true
      //     }
      //   )
      //   .then(function(res) {
      //     if (res.data.success) {
      //       _this.customerList = res.data.data;
      //     } else {
      //       _this.$message.error(res.data.message);
      //     }
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
    },
    loadChannel() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/channel'
      })
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            this.channelData = response.data.data;
            this.channelData.forEach((d, i) => {
              this.channelDataMap[d.id] = d.nameCN;
            });
          } else {
            this.channelData = [];
          }
          _this.loadWarehouse();
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadWarehouse() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/warehouse'
      })
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            this.warehouseData = response.data.data;
            this.flag = true;
            this.getMapForm(this.warehouseData[0]);
            if (this.warehouseData.length == 1) {
              this.flag = false;
            }
            this.warehouse = [];
            response.data.data.forEach((d, i) => {
              d.title = d.name;
              d.position = d.position.split(",");

              let warehouse = { id: "", title: "" };
              warehouse.id = d.id;
              warehouse.title = d.name;
              this.warehouse.push(warehouse);
            });
            this.initialDataWarehouseAddress = response.data.data;
            // this.currentWarehouseAddress = response.data.data[0];
            this.warehouseId = this.warehouseData[0].id;
          } else {
            this.warehouseData = [];
          }
          _this.onSubmit();
        })
        .catch(error => {});
    },
    findingOrderStage(val) {
      if (val && val.length > 0) {
        let _stageName = val[0].stageName;
        val.forEach((d, i) => {
          if (d.passed) {
            _stageName = "已" + d.stageName;
          }
        });
        return _stageName;
      } else {
        return "";
      }
    },
    fileChange(file, fileList) {
      this.templateFile = file.raw;
    },
    exceedFile(file, fileList) {
      fileList[0].name = file[0].name;
      fileList[0].raw = file[0];
      fileList[0].size = file[0].size;
      this.templateFile = file[0];
    },
    orderUpload() {
      let _this = this;
      var formData = new FormData();
      for (var key in _this.uploadForm.deliveryDetail) {
        if (key == "appointmentAt") {
          if (_this.uploadForm.deliveryDetail[key]) {
            let appointmentAt = _this.uploadForm.deliveryDetail[key];
            let oldTime = new Date(appointmentAt).getTime();
            oldTime = dateFormat(new Date(appointmentAt), "yyyy-MM-dd");

            formData.append(key, oldTime);
          }
        } else {
          formData.append(key, _this.uploadForm.deliveryDetail[key]);
        }
      }

      _this.channelData.forEach((d, i) => {
        if (_this.uploadForm.productId == d.id) {
          formData.append("productType", d.channelType);
          formData.append("productCountry", d.countryCode);
        }
      });
      if (!_this.templateFile || _this.templateFile.length == 0) {
        _this.$message.error("请选择文件。");
        return false;
      }

      formData.append("productId", _this.uploadForm.productId);
      formData.append("warehouseId", _this.uploadForm.warehouseId);
      formData.append("template", _this.templateFile);
      formData.append("customsId", _this.uploadForm.customsId);

      let _valid = true;
      _this.$refs["uploadForm"].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }

      if (_this.templateFile == null) {
        _this.$message.error("请上传Excel文件。");
        return false;
      }
      if (!_this.uploadForm.warehouseId) {
        _this.$message.error("请选择仓库。");
        return false;
      }
      if (
        _this.uploadForm.deliveryDetail.deliveryType ==
          "PICK_UP_FROM_CUSTOMER" &&
        (!_this.uploadForm.deliveryDetail.appointmentAt ||
          !_this.uploadForm.deliveryDetail.phone ||
          !_this.uploadForm.deliveryDetail.contractName ||
          !_this.uploadForm.deliveryDetail.province ||
          !_this.uploadForm.deliveryDetail.city ||
          !_this.uploadForm.deliveryDetail.addressFirst)
      ) {
        _this.$message.error("请填写地址和时间。");
        return false;
      } else if (
        _this.uploadForm.deliveryDetail.deliveryType == "DELIVERY" &&
        !_this.uploadForm.deliveryDetail.appointmentAt
      ) {
        _this.$message.error("请选择时间。");
        return false;
      } else if (
        _this.uploadForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS" &&
        (!_this.uploadForm.deliveryDetail.expressNumber ||
          !_this.uploadForm.deliveryDetail.expressCompany)
      ) {
        _this.$message.error("请填写快递单号和快递公司。");
        return false;
      }
      _this.$request1
        .post(
          '/order/excel',
          formData,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 413) {
            this.$notify.error({
              title: "创建订单失败,异常提示:",
              message:
                "Excel文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else if (response.data.success) {
            this.dialogUpLoadVisible = false;
            this.$notify.success({
              title: "创建订单成功,订单号为:",
              message: response.data.message,
              duration: 0
            });
            this.onLoad();
          } else {
            this.$notify.error({
              title: "创建订单失败,异常提示:",
              message: response.data.message,
              duration: 0
            });
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response.status === 413) {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    changedeliveryType(v) {
      let _this = this;
      if (v == "DELIVERY" || v == "DELIVERY_BY_EXPRESS") {
        //送货到仓库
        _this.uploadForm.warehoustId = _this.currentWarehouseAddress.id;
        _this.uploadForm.deliveryDetail.warehouseCode =
          _this.currentWarehouseAddress.id;
        _this.uploadForm.deliveryDetail.contractName =
          _this.currentWarehouseAddress.receiptPersonName;
        _this.uploadForm.deliveryDetail.phone =
          _this.currentWarehouseAddress.receiptPersonPhone;
        _this.uploadForm.deliveryDetail.country =
          _this.currentWarehouseAddress.countryCode;
        _this.uploadForm.deliveryDetail.province =
          _this.currentWarehouseAddress.province;
        _this.uploadForm.deliveryDetail.city =
          _this.currentWarehouseAddress.city;
        _this.uploadForm.deliveryDetail.addressFirst =
          _this.currentWarehouseAddress.address;
      } else if (v == "PICK_UP_FROM_CUSTOMER") {
        //上门取件
        _this.uploadForm.deliveryDetail.contractName = "";
        _this.uploadForm.deliveryDetail.phone = "";
        _this.uploadForm.deliveryDetail.country = "";
        _this.deliveryDetail.provinceId = "";
        _this.uploadForm.deliveryDetail.province = "";
        _this.uploadForm.deliveryDetail.city = "";
        _this.uploadForm.deliveryDetail.addressFirst = "";

        if (_this.shippingList && _this.shippingList.length > 0) {
          let _find = false;
          _this.shippingList.forEach((d, i) => {
            if (d.defaultAddress) {
              _find = true;
              _this.selectShippingAddress(d.id);
            }
          });
          if (!_find) {
            _this.selectShippingAddress(_this.shippingList[0].id);
          }
        }
      }
    },
    //高德地图保存地址
    handleSmenSaveMap() {
      this.mapAddressFormVisible = false;
      this.userCarry[0].title = this.mapObj.title;
      this.userCarry[0].address = this.mapObj.address;
      this.userCarry[0].name = this.mapObj.name;
      this.userCarry[0].phone = this.mapObj.phone;
      this.userCarry[0].distance = this.mapObj.distance;
    },
    //点击仓库
    getMapForm(val) {
      this.mapObj = val;
      this.currentWarehouseAddress = val;
      this.uploadForm.warehouseId = val.id;
      if (
        this.uploadForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.uploadForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS"
      ) {
        this.uploadForm.deliveryDetail.warehouseCode = val.id;
        this.uploadForm.deliveryDetail.contractName = val.receiptPersonName;
        this.uploadForm.deliveryDetail.phone = val.receiptPersonPhone;
        this.uploadForm.deliveryDetail.country = val.countryCode;
        this.uploadForm.deliveryDetail.province = val.province;
        this.uploadForm.deliveryDetail.city = val.city;
        this.uploadForm.deliveryDetail.addressFirst = val.address;
      }

      if (this.isInit) {
        this.userCarry[0].title = val.name;
        this.userCarry[0].address = val.address;
        this.userCarry[0].name = val.receiptPersonName;
        this.userCarry[0].phone = val.phone;
        this.userCarry[0].distance = val.distance;
        this.isInit = false;
      }
    },
    //获取经纬度：
    getGeocoder(val) {
      console.log("获取经纬度： " + JSON.stringify(val));
    },
    //地图编辑地址
    handleMapEdit(index, row) {
      var self = this;
      this.mapAddressFormVisible = true;
      if (!this.isOpen) {
        clearTimeout(timer);
        let timer = setTimeout(function() {
          self.$refs.spAmap.appendChild(document.getElementById("sp-amap"));
          self.isOpen = true;
        }, 50);
      }
    },
    //编辑地址
    handleEdit(index, row) {
      this.addressFormVisible = true;
    },
    saveAddressOfDeliver() {
      let _this = this;
      _this.addressFormVisible = false;
      _this.initialDataProvinceChina.forEach((d, i) => {
        if (_this.deliveryDetail.provinceId == d.id) {
          _this.uploadForm.deliveryDetail.province = d.nameCn;
        }
      });
      _this.initialDataCityChina.forEach((d, i) => {
        if (_this.deliveryDetail.cityId == d.id) {
          _this.uploadForm.deliveryDetail.city = d.nameCn;
        }
      });
      alert(_this.uploadForm.deliveryDetail.city);
    },
    queryCityOfChina(provinceId) {
      var _this = this;
      _this.uploadForm.deliveryDetail.city = "";
      _this.$request1
        .get(
          '/city/' + provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCityChina = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handlePrintPop(val) {
      this.dialogCheckVisible2 = true;
      this.thePrintId = val;
    },
    handlePrint() {
      this.dialogCheckVisible2 = false;
      let url = '/cartonlabel/' + this.thePrintId + '/' + this.printType + '';
      this.$windowOpen1(url);
    },
    showTrackingNumber(row) {
      let _this = this;
      this.showTrackingNumberWindow = true;
      this.trackingNumbers = row.trackingNumbers;
    },
    addressDialogPop() {
      this.shippingForm = {
        id: "",
        country: "",
        province: "",
        city: "",
        fbacode: "",
        address: "",
        name: "",
        phone: "",
        zipcode: "",
        type: "SHIPPING",
        defaultAddress: false
      };
      this.addressDialogVisible = true;
    },
    closeAddressPanel() {
      this.addressDialogVisible = false;
      this.queryAddress("SHIPPING");
    },
    selectWarehouse() {
      this.warehouseData.forEach((item, index) => {
        if (item.id == this.warehouseId) {
          this.getMapForm(item);
          this.userCarry[0].title = item.name;
          this.userCarry[0].address = item.address;
          this.userCarry[0].name = item.receiptPersonName;
          this.userCarry[0].phone = item.phone;
        }
      });
    },
    closeCheckOrderDialog() {
      this.dialogCheckOrderVisible = false;
      this.showDetailContent = false;
      this.show = false;
    },
    //确认发货
    confirmShipping() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }
      var formData = { orderIds: [] };

      for (let i = 0; i < this.multipleSelection.length; i++) {
        formData.orderIds.push(this.multipleSelection[i].id);
      }
      this.$request1({
        url: '/order/batch-confirm-delivery',
        method: "post",
        data: formData,
        withCredentials: true,
        headers: { "Content-Type": "application/json" }
      })
        .then(function(res) {
          if (res.data.succeed) {
            if (res.data.message != null) {
              _this.$alert(res.data.message, "提示");
              return;
            }
            var t = "";
            res.data.responses.forEach(a => {
              if (a.succeed) {
                setTimeout(() => {
                  _this.search(); //成功后就刷新
                }, 1500);
                t += "订单" + a.orderId + "确认发货成功！<br>";
              } else {
                t += "订单" + a.orderId + a.message + "<br>";
              }
            });

            _this.$alert(t, {
              title: "提示",
              dangerouslyUseHTMLString: true
            });
          } else {
            _this.$alert(res.data.message, "异常提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 导出箱明细
    exportCartons(){
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }

      var url = '/order/export-cartons';

      let orderIds = this.multipleSelection.map(a => a.id)

      this.$request1({
          url: url,
          method: 'post',
          data: {
            orderId: orderIds
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `cartons_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })

      // var form = document.createElement("form");
      // form.method = "post";
      // form.action = url;
      // form.target = "_blank";
      // document.body.appendChild(form);

      // this.multipleSelection.forEach(a => {
      //   var input = document.createElement("input");
      //   input.type = "hidden";
      //   input.name = "orderId[]";
      //   input.value = a.id;
      //   form.appendChild(input);
      // });

      // form.submit();
      
    },
    // 取消订单
    cancelOrder(index, row) {
      // console.log(row);
      this.$confirm("确定要取消该订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'GET',
            url: '/order/cancelOrder',
            params: {
              orderId: row.id,
              refNumber: row.customerRefnumber.customerOrderNumber,
              orgOwner: row.orgOwner
            },
            withCredentials: true
          })
            .then(response => {
              if (response.data.success) {
                this.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });
              } else {
                this.$notify({
                  title: "失败",
                  message: response.data.message,
                  type: "error"
                });
              }
              this.onLoad();
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },
    //编辑上传订单
    editUploadOrder(row) {
      // console.info("row:"+JSON.stringify(row));
      let querydeliveryDetail = row.deliveryDetail;
      let deliAddress = querydeliveryDetail.address;

      this.editForm = {
        orderId: row.id,
        orgOp: row.orgOp,
        orgOwner: row.orgOwner,
        warehousCode: row.warehousCode,
        productId: row.product,
        product: row.productName,
        remark: row.remark,
        customerRefnumber: row.customerRefnumber,
        deliveryDetail: {
          deliveryType: querydeliveryDetail.deliveryType,
          warehouseCode: querydeliveryDetail.warehouseCode,
          appointmentAt: new Date(querydeliveryDetail.appointmentAt),

          expressCompany: querydeliveryDetail.shipment.provider,
          expressNumber: querydeliveryDetail.shipment.trackingNumber,

          contractName: querydeliveryDetail.contractDatail.name,
          phone: querydeliveryDetail.contractDatail.phone,

          country: deliAddress.country,
          province: deliAddress.province,
          provinceId: deliAddress.province,
          city: deliAddress.city,
          addressFirst: querydeliveryDetail.address.address
        }
      };
      this.dialogCheckVisibleEditUpload = true;
    },
    //订单上传更新
    editUploadOrderInfo() {
      var _this = this;
      var formData = new FormData();
      if (!_this.editForm.orderId) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      } else {
        formData.append("orderId", _this.editForm.orderId);
      }
      if (!_this.templateFile || _this.templateFile.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择文件",
          type: "warning"
        });
        return false;
      } else {
        formData.append("template", _this.templateFile);
      }
      this.$confirm("您确定要更新上传订单吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            url: '/order/edit-upload',
            method: "post",
            data: formData,
            withCredentials: true,
            headers: { "Content-Type": "multipart/form-data" }
          })
            .then(function(res) {
              //console.log(res);
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "更新成功"
                });
                callback: action => {
                  _this.$router.push("/order");
                };
                _this.templateFile = "";
                _this.fileList = [];
                _this.dialogCheckVisibleEditUpload = false;
                _this.onSubmit();
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
                callback: action => {};
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    queryTrackingInfo(orderId) {
      this.$request1({
        method: 'GET',
        url: '/order/query/trackingInfo',
        params: {
          orderId: orderId
        },
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(res => {
          this.trackingNumberArray = [];
          if (res.data.success && res.data.data != null) {
            res.data.data.forEach(d => {
              if (d.eventName.includes("[") && d.eventName.endsWith("]")) {
                let eventName = d.eventName.split("[")[0],
                  detail = d.content,
                  eventAt = d.eventAt,
                  warning = d.warning,
                  trackingNo = d.eventName.split("[")[1].slice(0, -1);

                let trackingNoTemp = [];
                this.trackingNumberArray.forEach((item, index) => {
                  // 取所有的转单号存到一个数组中
                  trackingNoTemp.push(item.trackingNo);
                });

                if (
                  trackingNoTemp.length === 0 ||
                  !trackingNoTemp.includes(trackingNo)
                ) {
                  // 首次添加
                  this.trackingNumberArray.push({
                    trackingNo: trackingNo,
                    collapsed: true,
                    details: [
                      {
                        eventName: eventName,
                        detail: detail,
                        eventAt: eventAt,
                        warning: warning
                      }
                    ]
                  });
                } else {
                  this.trackingNumberArray.forEach((item, index) => {
                    if (item.trackingNo === trackingNo) {
                      item.details.push({
                        eventName: eventName,
                        detail: detail,
                        eventAt: eventAt,
                        warning: warning
                      });
                    }
                  });
                }
              }
            });
          }
        })
        .catch(function(error) {});
    }
  }
};
</script>

<style lang="scss">
.tms-order__page {
  #sp-amap {
    position: fixed;
    top: 0;
    right: 100%;
    &.isOpen {
      position: relative;
      right: 0;
    }
  }
  .el-table .cell {
    .trace-item {
      height: 34px;
      line-height: 34px;
      margin: 0 -10px;
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: 1px solid #ebeef5;
    }
    > .trace-item:first-child {
      margin-top: -10px;
    }
    > .trace-item:last-child {
      border-bottom: none;
      margin-bottom: -10px;
    }
  }
  .red {
    color: red;
  }
  .template-btn {
    color: #409eff;
  }
  .table {
    width: 100%;
    thead tr th,
    tbody tr td {
      padding-left: 15px;
      // color: #99a9bf;
      border: 1px dotted #ebeef5;
    }
  }
  .download-icon,
  .toggle-icon {
    color: rgb(58, 142, 230);
    &:hover {
      text-decoration: underline;
    }
  }
  .toggle-icon {
    margin-left: 15px;
    user-select: none;
    font-size: 12px;
    b {
      font-weight: 400;
    }
  }
  .button-groups {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .newOrderModel {
    width: 500px;
    .el-select {
      width: 80%;
    }
  }
}

.step-content {
  // margin-top: 20px;
  .step-content__title {
    margin-bottom: 15px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #ff9900;
    border-bottom: 1px dashed #dcdfe6;
  }
}

.tracking-number__table {
  margin-top: 20px;
  thead tr th,
  tbody tr td {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    &:last-child {
      border-right: 1px solid #ebeef5;
    }
  }
  thead tr th {
    padding: 12px;
  }
  tbody tr {
    td {
      padding: 6px 0;
      vertical-align: top;
      > .item {
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        &:not(:first-child) {
          color: #99a9bf;
          border-top: 1px dashed #e5e5e5;
        }
        &.warning {
          color: #f56c6c;
        }
      }
    }
    & > :first-child {
      width: 48px;
      text-align: center;
      a {
        transition: all 0.3s;
      }
    }
    & > :first-child,
    & > :nth-child(2) {
      padding: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/order/order.vue